export default class InteractiveCatalogPage {

    constructor() {
        this.pageId = '';
        this.title = '';
        this.description = '';

        this.horizontalIndexImage = '';
        this.verticalIndexImage = '';

        this.horizontalLayers = []; // List of InteractiveCatalogPageLayer
        this.verticalLayers = [];   // List of InteractiveCatalogPageLayer
        this.universalLayers = [];  // List of InteractiveCatalogPageLayer

        this.horizontalSize = undefined;    // CanvasDimension
        this.verticalSize = undefined;      // CanvasDimension
        this.universalSize = undefined;     // CanvasDimension

        this.openPageActions = [];  // List of ItemAction

        this.horizontalChangePageMode = '';
        this.verticalChangePageMode = '';

        this.horizontalPageVerticalScrollPager = false;
        this.verticalPageVerticalScrollPager = false;

        this.backgroundColor = '';
    }

}
